/** Carregando / erro de uma consulta. Sem isso, um 403 deixava a tabela vazia sem aviso (FE25). */
export function QueryStatus({ loading, error }: { loading?: boolean; error?: unknown }) {
  if (error)
    return (
      <div className="alert alert-danger m-3" role="alert">
        {error instanceof Error ? error.message : "Não foi possível carregar."}
      </div>
    );
  if (loading)
    return (
      <p className="p-3 text-muted mb-0" role="status">
        Carregando…
      </p>
    );
  return null;
}
